<h2 mat-dialog-title style="position: relative; color:#121212 !important">
  {{ data.title }}
  <div style="position: relative; bottom: 0; left: 0; width: 100%; height: 1px; background-color: #f5f5f5;"></div>
</h2>
<mat-dialog-content>
  <p class="my-3 text-center" style="font-weight: 600;">{{ data.paragraph }}</p>
</mat-dialog-content>
<mat-dialog-actions [style.justify-content]="'center'">
  <button mat-button class="btn reset-btn  btn-lg font-size-lg text-white" (click)="onNoClick()">{{"Form.CANCEL"|translate}}</button>
  <button mat-button class="btn btn-danger py-2 btn-lg font-size-lg" [mat-dialog-close]="true" cdkFocusInitial type="">{{"Form.Proceed"|translate}}</button>
</mat-dialog-actions>